<template>
    <div class="col-md-12" style="height: 100%;">
        <leave-count></leave-count>
        <h4 style="font-weight:600;padding-bottom: 5px">Leave History</h4>
        <div style="border-bottom: 1.5px dashed rgb(221, 221, 221);"></div>
        <leave-history></leave-history>
    </div>
</template>
<script>
import LeaveCount from './LeaveCount'
import LeaveHistory from './LeaveHistory'
export default {
    data() {
    return {
    }
  },
  components: {
    "leave-count":LeaveCount,
    "leave-history":LeaveHistory
  },
}
</script>


// WEBPACK FOOTER //
// src/components/ESSProfile/LeaveManagement/LeaveReport.vue